import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import ReactGA from 'react-ga4'
import './index.css'
import { routeTree } from './routeTree.gen'

if(!ReactGA.isInitialized){
  ReactGA.initialize((window as any)?.siteVar?.referer === 'IE' ? 'G-CT46K5CJXJ' : 'G-SKPFMZ4RJB')
}

const router = createRouter({ routeTree, basepath: '/flights' })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
)
